
<template>
  <div>
    <v-overlay :value="isLoading">
  <v-progress-circular
    indeterminate
    size="64"
  ></v-progress-circular>
</v-overlay>

    <v-data-table  
          :headers="headers"
          :items="mapafrequencia.items"      
          :sort-desc="true"      
          class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">            
          <v-row>
            <v-col cols="12" sm="3" md="3"> <v-toolbar-title>Mapa de Frequência dos estudantes</v-toolbar-title></v-col>
          <v-col cols="12" sm="3" md="3">
              <v-select
                :items="Listaranoslectivo"
                v-model="anolectivo"
                item-value="descricao"
                item-text="novadescricao"
                label="Selecione o Ano lectivo"
                outlined
                return-object
              ></v-select>      
  </v-col>
  <v-col cols="12" sm="4" md="4">
              <v-select
                :items="trimestres"
                v-model="trimestre"
                item-value="id"
                item-text="descricao"
                @change="carregarMapaFrequencia()"
                label="Selecione o Trimestre"
                outlined
                :disabled="!anolectivo"
                return-object
              ></v-select>      
  </v-col>
  <v-col cols="12" sm="2" md="2">
    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn large fab color="#006699" @click="comporHTML()"
                        :disabled="!mapafrequencia.items.length"
                          v-bind="attrs"
                          v-on="on"
                        >
                        <v-icon color="white">print</v-icon>
                          </v-btn>
                      </template>
                      <span>Clique aqui para visualizar o PDF</span>
                  </v-tooltip>
    </v-col>
</v-row>
          <v-spacer></v-spacer>    
        </v-toolbar>
</template>          
      <template v-slot:no-data>
        no data
      </template>
    </v-data-table>
  
     
  </div>
  </template>
<script>
import axios from '../../../../plugins/axios'
import impressao from '../../../../utilitarios/impressao.utilitario'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
data: () => ({
relatorio: '',
mapafrequencia: {items:[],totais:null},
html: ``,
isLoading: true,
Listaranoslectivo: [],
professores: [],
trimestres:[
  {id:1,descricao:'Iº Trimestre'},
  {id:2,descricao:'IIº Trimestre'},
  {id:3,descricao:'IIIº Trimestre'}
],
trimestre: null,
anolectivo: null,

headers: [
  {
    text: 'Classes',
    align: 'left',
    sortable: false,
    value: 'classe'
  },
  { text: 'Matriculados', value: 'matriculadosmf' },
  { text: 'Desistidos', value: 'desistentesmf' },
  { text: 'Avaliados', value: 'avaliadosmf' },
   { text: 'C/Aproveitamento', value: 'comaproveitamentomf' },
  { text: 'S/Aproveitamento', value: 'semaproveitamentomf' },
  
  
],

}),
computed: {
},
watch: {
},
created  () {
this.carregarRelatorio()   
this.carregarAnosLectivo() 
},
methods: {
async carregarAnosLectivo () {
  try {
    this.isLoading = true
    this.Listaranoslectivo = await axios.get('/listarAnoLectivoAll').then(res => res.data)
  } catch (error) {
    Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar os anos lectivos' })    
    this.isLoading = false
  } finally {
    this.sair()
  }
},

async carregarRelatorio () {
  try {
    this.isLoading = true
    this.relatorio = await axios.get('/obterRelatorioByDescricao/mat').then(res => res.data) 
  } catch (error) {
    this.sair()
    Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar o relatório' })
  }
},
async carregarMapaFrequencia () {
  try {     
    this.isLoading = true   
    this.mapafrequencia = await axios.get('/mapaAproveitamentoByAnoLectivo/' + this.anolectivo.descricao + '/' + this.trimestre.id).then(res => res.data) 
    this.professores = await axios.get('/mapaAproveitamentoTrimestreProf/' + this.anolectivo.descricao).then(res => res.data) 
  } catch (error) {
    this.sair()
    Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar o mapa de frequência' })
  } finally {
    this.sair()
  }
},
comporHTML () {
  if (this.mapafrequencia.items.length) {
  try {
    this.isLoading = true
    this.html = this.relatorio[0].documento
    let documentoiter = this.relatorio[0].documentoiteracao1
    let header = this.relatorio[0].documentoiteracao2
    
          let subtotal = { matriculadosmf: 0, matriculadosf: 0, desistentesmf: 0, desistentesf: 0, avaliadosmf: 0, avaliadosf: 0, comaproveitamentomf: 0, comaproveitamentof: 0, semaproveitamentomf: 0, semaproveitamentof: 0, comaproveitamentopercentmf: 0, comaproveitamentopercentf: 0 }
          this.mapafrequencia.items.forEach(element => {
            // @ts-ignore
            subtotal.matriculadosmf += parseInt(element.matriculadosmf)
            // @ts-ignore
            subtotal.matriculadosf += parseInt(element.matriculadosf)

            // @ts-ignore
            subtotal.desistentesmf += parseInt(element.desistentesmf)
            // @ts-ignore
            subtotal.desistentesf += parseInt(element.desistentesf)

            // @ts-ignore
            subtotal.avaliadosmf += parseInt(element.avaliadosmf)
            // @ts-ignore
            subtotal.avaliadosf += parseInt(element.avaliadosf)

            // @ts-ignore
            subtotal.comaproveitamentomf += parseInt(element.comaproveitamentomf)
            // @ts-ignore
            subtotal.comaproveitamentof += parseInt(element.comaproveitamentof)

            // @ts-ignore
            subtotal.semaproveitamentomf += parseInt(element.semaproveitamentomf)
            // @ts-ignore
            subtotal.semaproveitamentof += parseInt(element.semaproveitamentof)

            // @ts-ignore
            subtotal.comaproveitamentopercentmf += parseInt(element.comaproveitamentopercentmf)
            // @ts-ignore
            subtotal.comaproveitamentopercentf += parseInt(element.comaproveitamentopercentf)
          })
    this.html = this.html.replace(/{{instituicao}}/g, ls.get('instituicaodescricao').toUpperCase())
    this.html = this.html.replace(/{{anolectivo}}/g, this.anolectivo.novadescricao)
    this.html = this.html.replace(/{{trimestre}}/g, this.trimestre.descricao)
    this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
    this.html = this.html.replace(/{{dataactual}}/g, this.correntDate()) 
    /**Totais */
    this.html = this.html.replace(/{{totalmfmatriculados}}/g, subtotal.matriculadosmf)
    this.html = this.html.replace(/{{totalfmatriculados}}/g, subtotal.matriculadosf)

    this.html = this.html.replace(/{{totalmfdesistentes}}/g, subtotal.desistentesmf)
    this.html = this.html.replace(/{{totalfdesistentes}}/g, subtotal.desistentesf)

    this.html = this.html.replace(/{{totalmfavaliados}}/g, subtotal.avaliadosmf)
      this.html = this.html.replace(/{{totalfavaliados}}/g, subtotal.avaliadosf)

      this.html = this.html.replace(/{{totalmfaprovados}}/g, subtotal.comaproveitamentomf)
      this.html = this.html.replace(/{{totalfaprovados}}/g, subtotal.comaproveitamentof)

      this.html = this.html.replace(/{{totalmfreprovados}}/g, subtotal.semaproveitamentomf)
      this.html = this.html.replace(/{{totalfreprovados}}/g, subtotal.semaproveitamentof)

      this.html = this.html.replace(/{{totalmfc_aproveitamento}}/g, subtotal.comaproveitamentopercentmf)
      this.html = this.html.replace(/{{totalfc_aproveitamento}}/g, subtotal.comaproveitamentopercentf)

      this.html = this.html.replace(/{{totalmfprof}}/g, this.professores.total.mf)
      this.html = this.html.replace(/{{totalfprof}}/g, this.professores.total.f)
   
    let dados = ``
    let i = 0
    this.mapafrequencia.items.forEach(element => {
      let iteracao = documentoiter
      iteracao = iteracao.replace(/{{classe}}/g, element.classe)

      iteracao = iteracao.replace(/{{mfmatriculados}}/g, element.matriculadosmf)
      iteracao = iteracao.replace(/{{fmatriculados}}/g, element.matriculadosf)

      iteracao = iteracao.replace(/{{mfdesistentes}}/g, element.desistentesmf)
      iteracao = iteracao.replace(/{{fdesistentes}}/g, element.desistentesf)

      iteracao = iteracao.replace(/{{mfavaliados}}/g, element.avaliadosmf)
      iteracao = iteracao.replace(/{{favaliados}}/g, element.avaliadosf)

      iteracao = iteracao.replace(/{{mfaprovados}}/g, element.comaproveitamentomf)
      iteracao = iteracao.replace(/{{faprovados}}/g, element.comaproveitamentof)

      iteracao = iteracao.replace(/{{mfreprovados}}/g, element.semaproveitamentomf)
      iteracao = iteracao.replace(/{{freprovados}}/g, element.semaproveitamentof)

      iteracao = iteracao.replace(/{{mfc_aproveitamento}}/g, Math.round((element.avaliadosmf > 0 && element.comaproveitamentomf > 0) ? ((element.comaproveitamentomf*100)/element.avaliadosmf) : 0))
      iteracao = iteracao.replace(/{{fc_aproveitamento}}/g, Math.round((element.avaliadosf > 0 && element.comaproveitamentof > 0) ? ((element.comaproveitamentof*100)/element.avaliadosf) : 0))

      iteracao = iteracao.replace(/{{mfprof}}/g, this.professores.items[i].mfprof)
      iteracao = iteracao.replace(/{{fprof}}/g, this.professores.items[i].fprof)
      
      i++
      dados += iteracao
  })
  this.html = this.html.replace(/{{css}}/g, this.relatorio[0].css)
  this.html = this.html.replace(/{{dados}}/g, dados)
    let options = { 'format': 'A4',
    'orientation': 'landscape',
    'border': {
      'right': '12mm',
      'left': '12mm'
    },
    'header': {
      'height': '10mm',
      'contents': { first: header } },
    'footer': {
      'height': '10mm'

    } }
    impressao.htmlToPDF(this.html,options,ls.get('urlReport'),ls.get('idPessoa'))
  } catch (error) {
    this.sair()
    Swal.fire({icon: 'error',title: '', text: 'Ocorreu um erro ao abrir o documento'})
  } finally {
    this.sair()
  }
}
},   
sair(){ this.isLoading =false },
correntDate () {
  let data = new Date()
  var month = []
  month[0] = 'Janeiro'
  month[1] = 'Fevereiro'
  month[2] = 'Março'
  month[3] = 'Abril'
  month[4] = 'Maio'
  month[5] = 'Junho'
  month[6] = 'Julho'
  month[7] = 'Agosto'
  month[8] = 'Setembro'
  month[9] = 'Outubro'
  month[10] = 'Novembro'
  month[11] = 'Dezembro'
  return  'Luanda, ' + data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString()
}
}
}

</script>
